import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';

import RichTextNotesHeader from './RichTextNotesHeader';
import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import SubSkillsFieldArray from './SubSkillsFieldArray';

class FeedbackSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        contentValues: PropTypes.object.isRequired,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, contentValues, isGlobalSectionItem } = this.props;

        return (
            <div className={'feedbackSectionItem col-12'}>
                <RichTextNotesHeader isFeedback={true} />
                <Field
                    name={memberReference ? `${memberReference}.content.employeePrompt` : 'content.employeePrompt'}
                    label={'Employee Prompt'}
                    rows={3}
                    component={VerbRichTextEditor}
                    readOnly={isGlobalSectionItem}
                />
                <Field
                    name={memberReference ? `${memberReference}.content.colleaguePrompt` : 'content.colleaguePrompt'}
                    label={'Colleague Prompt'}
                    rows={3}
                    component={VerbRichTextEditor}
                    readOnly={isGlobalSectionItem}
                />
                <Field
                    name={memberReference ? `${memberReference}.content.explanation` : 'content.explanation'}
                    label={'Instructions and/or Explanation for Prompt - No text replacement!'}
                    rows={3}
                    component={VerbRichTextEditor}
                    readOnly={isGlobalSectionItem}
                />
                <FieldArray
                    name={memberReference ? `${memberReference}.content.subSkills` : 'content.subSkills'}
                    contentValues={contentValues}
                    component={SubSkillsFieldArray}
                    disabled={isGlobalSectionItem}
                />
                <Field
                    name={
                        memberReference ? `${memberReference}.content.hideResponseSlide` : 'content.hideResponseSlide'
                    }
                    label={'Hide Response Slide?'}
                    component={BasicToggle}
                    disabled={isGlobalSectionItem}
                    id={'feedback-hide-response-toggle'}
                />
            </div>
        );
    }
}

export default FeedbackSectionItem;
